/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SquadEntryResponse = {
    properties: {
        id: {
            type: 'string',
            format: 'uuid4',
        },
        timestamp: {
            type: 'string',
            format: 'date-time',
        },
        userId: {
            type: 'number',
            isRequired: true,
        },
        action: {
            type: 'SquadAuditLogEnum',
            isRequired: true,
        },
        personId: {
            type: 'number',
            isRequired: true,
        },
        squadType: {
            type: 'PersonTypeEnum',
            isRequired: true,
        },
        payload: {
            type: 'any-of',
            contains: [{
                type: 'CoachCreate',
            }, {
                type: 'CoachPatch',
            }, {
                type: 'CoachStopWithCoach',
            }, {
                type: 'CoachStartWithCoach',
            }, {
                type: 'TransferCoachWithCoachAndTeam',
            }, {
                type: 'SquadPlayerCreate',
            }, {
                type: 'PlayerPatch',
            }, {
                type: 'PlayerStartWithPlayer',
            }, {
                type: 'PlayerStopWithPlayer',
            }, {
                type: 'TransferPlayerWithPlayerAndTeams',
            }, {
                type: 'PatchPlayerPosition',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        oldData: {
            type: 'any-of',
            contains: [{
                type: 'CoachCreate',
            }, {
                type: 'CoachPatch',
            }, {
                type: 'CoachStopWithCoach',
            }, {
                type: 'CoachStartWithCoach',
            }, {
                type: 'TransferCoachWithCoachAndTeam',
            }, {
                type: 'SquadPlayerCreate',
            }, {
                type: 'PlayerPatch',
            }, {
                type: 'PlayerStartWithPlayer',
            }, {
                type: 'PlayerStopWithPlayer',
            }, {
                type: 'TransferPlayerWithPlayerAndTeams',
            }, {
                type: 'PatchPlayerPosition',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        user: {
            type: 'UserSmall',
            isRequired: true,
        },
        person: {
            type: 'any-of',
            contains: [{
                type: 'Person',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
    },
} as const;
